export default "__VITE_ASSET__1db182ef__"